import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { UserPlatformDto } from '../../core/users/domain/user_platform_dto.entity';
import { Constants } from '../Constants';

@Injectable()
export class ModelsService {
  private _user: UserPlatformDto | null = null;
  public get user(): UserPlatformDto | null {
    return this._user;
  }
  public set user(value: UserPlatformDto | null) {
    this._user = value;
  }

  public get showHourglass(): boolean {
    return this.hourglass.getValue();
  }
  public set showHourglass(value: boolean) {
    this.hourglass.next(value);
  }

  public hourglass: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public hasReadAllNewsflash: boolean = false;

  public formDataFiles = new FormData();

  public eventLoginUser: EventEmitter<UserPlatformDto> =
    new EventEmitter<UserPlatformDto>();

  public onNotificationUpdate: EventEmitter<any> = new EventEmitter<any>();
  public onChatUpdate: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    protected http: HttpClient,
    protected router: Router,
    injector: Injector
  ) {}

  public isSuperAdmin(): boolean {
    return this.user?.role === Constants.ROLE_SYSTEM_SUPER_ADMINISTRATOR;
  }

  public isGeminusUser(): boolean {
    return (
      this.user?.role === Constants.ROLE_SYSTEM_SUPER_ADMINISTRATOR ||
      this.user?.role === Constants.ROLE_MONITOR
    );
  }

  public habilitarBotonesDeEdicion(): boolean {
    return (
      this.user?.role === Constants.ROLE_SYSTEM_ADMINISTRATOR ||
      this.user?.role === Constants.ROLE_SYSTEM_SUPER_ADMINISTRATOR ||
      this.user?.role === Constants.ROLE_OPERATOR ||
      this.user?.role === Constants.ROLE_MONITOR
    );
  }

  public IsOperator(): boolean {
    return this.user?.role === Constants.ROLE_OPERATOR;
  }

  public AllowFiliatorios(): boolean {
    return (
      this.user?.role === Constants.ROLE_SYSTEM_ADMINISTRATOR ||
      this.user?.role === Constants.ROLE_SYSTEM_SUPER_ADMINISTRATOR ||
      this.user?.role === Constants.ROLE_OPERATOR
    );
  }

  public AllowUserSearch(): boolean {
    return this.user?.role === Constants.ROLE_MONITOR;
  }
}
